import Swiper from 'swiper'
import { Pagination, Navigation } from 'swiper/modules'

function testimonialCarousel() {
    const sections = document.querySelectorAll('.testimonial-carousel')

    sections.forEach((section) => {
        const slider = section.querySelector('.swiper')
        const pagination = section.querySelector('.swiper-pagination')
        const next = section.querySelector('.testimonial-swiper-button-next')
        const prev = section.querySelector('.testimonial-swiper-button-prev')

        const swiper = new Swiper(slider, {
            modules: [Pagination, Navigation],
            loop: true,
            pagination: {
                el: pagination,
                clickable: true,
                bulletClass: 'swiper-pagination-bullet',
                bulletActiveClass: 'swiper-pagination-bullet-active',
                renderBullet: function (index, className) {
                    const logos = pagination.querySelectorAll('img')
                    if (logos[index]) {
                        return `<div class="${className} aspect-square bg-white w-50 h-50 lg:w-150 lg:h-150 rounded-full overflow-hidden flex items-center justify-center">
                            <img class="w-[80%] h-[80%] object-contain" src="${logos[index].src}">
                        </div>`
                    }
                    return ''
                },
            },
            navigation: {
                nextEl: next,
                prevEl: prev,
            },
        })
    })
}

export default testimonialCarousel
